import HealthCard from "./HealthCard";
export default HealthCard;
